import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentConfigService {

  environments = environment.environments;

  constructor() { }

  getEnvironment = () => {
    const host = window.location.hostname;
    for (let environment in this.environments){
        if (typeof(this.environments[environment].host) && typeof(this.environments[environment].host) == 'object') {
            for (let i = 0; i < this.environments[environment].host.length; i++) {
                if (host.includes(this.environments[environment].host[i])) {
                    return environment;
                }
            }
        } else {
            if (typeof(this.environments[environment].host) && host.endsWith(this.environments[environment].host)) {
                return environment;
            }
        }
    }
    return null;
  };

  get = (property: string) => {
    const environment = this.getEnvironment();
    return this.environments && environment && this.environments[environment].config[property];
  }
}
